// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-Container_cls1__szGHd","cls2":"StyledComponents-Container_cls2__jU-OK StyledComponents-Container_cls1__szGHd"};